import { getRoute } from '@utils/route';

export const PERSONAL_ACCIDENT_QUOTE_PAYMENT_PAGE_URL = '/personal-accident-insurance-quote-payment/:orderNumber/:billingId';

type RouteParams = {
  orderNumber: string;
  billingId: number;
};

export const routePersonalAccidentQuotePaymentPage = (routeParams: RouteParams) => getRoute(PERSONAL_ACCIDENT_QUOTE_PAYMENT_PAGE_URL, { routeParams });
